module.exports = __webpack_public_path__ + "img/sliders-01.035f6a91.svg";